<div *ngIf="block" class="container-highlighted-paragraph d-flex align-item-stretch {{classColumn}} bg-neutral-99">
    <div class="d-flex position-relative">
        <div class="custom-border" [ngClass]="block.colore === 'Verde' ? 'bg-brand-40' : 'bg-support-40'"></div>
        <div class="highlighted-paragraph-content d-flex flex-column">
            <div *ngIf="block.testo">
                <p *ngIf="block.colore == 'Oro'" class="ls-h3-section-title text-support-40 text-garamond"
                    [innerHTML]="block.testo"></p>
                <p *ngIf="block.colore == 'Verde'" class="ls-h3-section-title text-brand-40 text-garamond"
                    [innerHTML]="block.testo"></p>
            </div>
            <div *ngIf="block.testo_di_supporto">
                <p class="ls-p-medium" [innerHTML]="block.testo_di_supporto"></p>
            </div>
        </div>
    </div>
</div>